<template>
  <div>
    <CustomFilter
      ref="customFilter"
      :all-tags="allTags"
      :grid-size-filter-options="gridSizeFilterOptions"
      :options="filterOptions"
      @filterChanged="filterChanged" />

    <VueSlimTable
      ref="table"
      :source="tableSource"
      :columns="columns"
      class="table table-light live-config-table"
      :per-page="perPage">
      <template #row="{ row }">
        <TableRow :ref="`live-config-row-${row.obfuscatedId}`"
          :row="row"
          :geogrids-path="geogridsPath"
          @onDeleteRow="reload"
          @addTagToFilter="addTagToFilter" />
      </template>
      <template #head:gridRanks="{ column }">
        {{ column.title }}
        <i id='geogrid-ranks-tooltip' class="fa-info-circle fas float-right mt-1 text-primary" />
        <b-popover
          id='key-popover'
          placement='leftbottom'
          target='geogrid-ranks-tooltip'
          custom-class='geogrids-popover'
          triggers='click hover'>
          <div class='text-dark'>
            <b>AGR</b>
            <div class='mb-2'>Average Grid Rank. Only nodes with ranks equal to "20" and less considered.</div>
            <b>ATGR</b>
            <div class='mb-2'>Average Total Grid Rank. All nodes considered. The "21" value is used for nodes with ranks over "20".</div>
            <b>SoLV</b>
            <div>Share of Local Voice. Average value among nodes having ranks equal to "3" and less.</div>
          </div>
        </b-popover>
      </template>
      <template #pagination>
        <Pagination :page="currentPage" :per-page="perPage" :total-count="totalGeogrids" @updatePage="updatePageNumber" />
      </template>
    </VueSlimTable>
  </div>
</template>

<script>

import axios from 'axios'
import { mapState } from 'vuex'
import snakeCaseKeys from 'snakecase-keys'
import axiosTransform from '../../../common/axios'
import TableRow from './index/table_row'
import Pagination from '../../components/pagination'
import CustomFilter from '../components/filter'

const csrf = document.querySelector('meta[name="csrf-token"]')
axios.defaults.headers.common['X-CSRF-Token'] = csrf.getAttribute('content')

export default {
  name: 'GeogridsHistoryWidget',
  components: {
    TableRow, Pagination, CustomFilter
  },
  props: {
    initialData: Object,
    apiGeogridsPath: String,
    geogridsPath: String
  },
  data() {
    return {
      currentPage: 1,
      totalGeogrids: 0,
      perPage: 7,
      searchQuery: '',
      isBusy: false,
      filters: {},
      allTags: []
    }
  },
  created() {
    this.columns = [
      { key: 'business_name', title: 'Ranked business', orderable: true },
      { key: 'keyword', title: 'Search term', orderable: true },
      { key: 'created_at', title: 'Created', orderable: true },
      { key: 'grid_ranks', title: 'Grid Ranks', orderable: true },
      { key: 'grid', title: 'Grid Size', orderable: true },
      { key: 'actions', title: '' }
    ]
    this.gridSizeFilterOptions = ['', 3, 5, 7, 9, 13]
    this.filterOptions = {
      noShowDeleted: true,
      noWithUpdates: true
    }
  },
  computed: mapState(['deletedGeogridId']),
  methods: {
    addTagToFilter(tag) {
      if (this.$refs.customFilter.filters.selectedTags) {
        const tagIndex = this.$refs.customFilter.filters.selectedTags.indexOf(tag)
        if (tagIndex === -1) {
          this.$refs.customFilter.filters.selectedTags.push(tag)
        } else {
          this.$refs.customFilter.filters.selectedTags.splice(tagIndex, 1)
        }
      } else {
        this.$refs.customFilter.filters.selectedTags = [tag]
      }
    },
    filterChanged(filters) {
      this.filters = filters
      this.currentPage = 1
      this.reload()
    },
    tableSource(prms) {
      this.isBusy = true

      const params = {
        order: [{ field: 'created_at', direction: 'desc' }],
        ...prms,
        ...this.filters,
        page: this.currentPage
      }

      return axios.get(
        this.apiGeogridsPath,
        {
          params: snakeCaseKeys(params),
          paramsSerializer(json) { return qs.stringify(json, { arrayFormat: 'brackets' }) },
          ...axiosTransform
        }
      )
        .then((res) => {
          this.allTags = res.data.tags
          this.totalGeogrids = res.data.totalGeogrids
          return res.data.geogrids
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    updatePageNumber(page) {
      this.currentPage = page
      this.reload()
    },
    reload() {
      this.totalGeogrids = 0
      this.$refs.table.refetch()
    }
  },
  watch: {
    searchQuery() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }

      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1
        this.reload()
      }, 500)
    },
    deletedGeogridId() {
      this.reload()
    }
  }
}
</script>
